export const STUDENT_EVALUATION = "Students";
export const COACH_EVALUATION = "Survey for Coach";
export const PARENT_EVALUATION = "Parents";



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/components/sport-table/components/survey-link/utils/constants.ts